const VOIDED = new Set(['split', 'merged', 'deleted']);
const EXCEPTION = new Set(['held', 'escalated', 'rejected', 'error']);
const QUEUED = new Set(['pending', 'ready']);
const IN_PROCESS = new Set(['assigned', 'in_progress', 'completed']);
/**
 * Single source of truth for a document's canonical lifecycle phase, derived
 * from columns that already exist. Evaluated top-down (first match wins).
 * Never throws; an unrecognized state degrades to `exception` so it surfaces
 * rather than vanishing. (Q-d / Q-e — design §2.2.)
 */
export function getDocumentPhase(doc) {
    const { status, currentStep, assignedTo, imagesPurgedAt, hasLiveLock } = doc;
    if (VOIDED.has(status))
        return 'voided';
    if (status === 'exported')
        return imagesPurgedAt != null ? 'purged' : 'exported';
    if (EXCEPTION.has(status))
        return 'exception';
    if (currentStep === 'classify' && status === 'ready')
        return 'awaiting_release';
    if (IN_PROCESS.has(status) || hasLiveLock || assignedTo != null)
        return 'in_process';
    if (QUEUED.has(status))
        return 'queued';
    return 'exception';
}
export const ACTIVE_PHASES = [
    'queued', 'in_process', 'awaiting_release', 'exception',
];
export const TERMINAL_PHASES = ['exported', 'purged', 'voided'];
const ACTIVE_SET = new Set(ACTIVE_PHASES);
export function isActivePhase(p) {
    return ACTIVE_SET.has(p);
}
export function isTerminalPhase(p) {
    return !ACTIVE_SET.has(p);
}
/** The design §3 visibility matrix as data: which surface(s) DISPLAY each phase. */
export const PHASE_SURFACES = {
    queued: ['queues', 'batches_active'],
    in_process: ['queues', 'batches_active'],
    awaiting_release: ['queues', 'batches_active'],
    exception: ['queues', 'batches_active'],
    exported: ['history'],
    purged: ['history'],
    voided: ['history'],
};
//# sourceMappingURL=document-phase.js.map